import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import useMediaQuery from '@material-ui/core/useMediaQuery';

import { FormModal } from 'components/common/modals';
import { BasicButton } from 'components/common/buttons';
import { DynoForm } from 'components/dyno-template';

import { MODAL_FULLSCREEN_SIZE } from 'settings/constants/ui-control';

const RenewPasswordModal = ({
  title,
  serviceTitle,
  isOpen,
  onClose,
  onSubmit,
  formDetail,
  hasNoteContent,
  fields,
  notes,
  onChange,
  actionButtonTitle,
  className,
  isPasswordMatch,
}) => {
  const { formatMessage } = useIntl();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(MODAL_FULLSCREEN_SIZE));

  const footerButton = (
    <Grid container justify="flex-end" spacing={3}>
      <Grid item>
        <BasicButton className="transparent-bb db" onClick={onClose} title={formatMessage({ id: 'buttonText.cancel' })} />
      </Grid>
      <Grid item className="ml3">
        <BasicButton
          className="db"
          disabled={!isPasswordMatch}
          onClick={() => onSubmit(formDetail)}
          title={formatMessage({ id: actionButtonTitle })}
        />
      </Grid>
    </Grid>
  );

  return (
    <FormModal
      fullWidth
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullScreen={fullScreen}
      hasContentHeader={false}
      className={`modal--transfer ${className}`}
      title={title && formatMessage({ id: title }, serviceTitle)}
      footer={footerButton}
    >
      <DynoForm fields={fields} formDetail={formDetail} onChange={onChange} />

      {hasNoteContent && (
        <Grid container alignItems="center" className="modal--note mt4 ma3">
          <Grid item xs={12}>
            {notes}
          </Grid>
        </Grid>
      )}
    </FormModal>
  );
};

RenewPasswordModal.defaultProps = {
  notes: [],
  serviceTitle: {},
  actionButtonTitle: 'buttonText.transfer',
  className: '',
  isPasswordMatch: false,
};

RenewPasswordModal.propTypes = {
  serviceTitle: PropTypes.object,
  className: PropTypes.string,
  actionButtonTitle: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  fields: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  formDetail: PropTypes.object.isRequired,
  hasNoteContent: PropTypes.bool.isRequired,
  notes: PropTypes.object,
  isPasswordMatch: PropTypes.bool,
};

export default RenewPasswordModal;
